var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu-categories"},[_c('div',{staticClass:"menu-categories__list"},_vm._l((_setup.menuModel.menuUser),function(category){return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
        el: '#' + 'item_' + category.id,
        offset: -140,
        duration: 250,
      }),expression:"{\n        el: '#' + 'item_' + category.id,\n        offset: -140,\n        duration: 250,\n      }"}],key:category.id,staticClass:"menu-categories__item",attrs:{"href":"#"}},[_vm._v("\n      "+_vm._s(category.internal_name && category.internal_name !== '-'
          ? category.internal_name
          : category.name)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }